// No TTL: a temporary transport/application failure is not a logout decision.
export const newRequestId = () => window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
export const sessionDecision = (result) => {
  if (result?.success && result?.authState === 'valid') return 'valid';
  if (['invalid', 'inactive'].includes(result?.authState)) return 'clear';
  if (result?.authState === 'forbidden') return 'forbidden';
  return 'retry';
};
export const isCurrentToken = token => localStorage.getItem('accessToken') === token;
export const clearCurrentToken = token => {
  if (!token || !isCurrentToken(token)) return false;
  localStorage.removeItem('accessToken');
  return true;
};
